import CarouselHeader from '@components/Carousel/components/Header';
import { RecipeCard, RecipeCardLoading } from '@ui';

import './index.scss';

const RecipesCarouselMobile = ({ recipes, title, isTitleLink }) => (
  <div className='recipes-mobile'>
    <CarouselHeader isTitleLink={isTitleLink} title={title} />
    <div className='recipes-mobile__slider hide-scroll-mobile'>
      {recipes.length > 0
        ? recipes?.map(item => (
            <div className='recipes-mobile__recipe' key={item.id}>
              <RecipeCard item={item} />
            </div>
          ))
        : Array.from({ length: 5 }).map((_, index) => (
            <div className='recipes-mobile__recipe' key={`loading-${index}`}>
              <RecipeCardLoading />
            </div>
          ))}
    </div>
  </div>
);

export default RecipesCarouselMobile;
